export default __webpack_public_path__ + "static/media/DreamStreamDark.2a6a51b4.svg";